import { create } from 'zustand';

/**
 * UI state for the Admin Template Edit page.
 *
 * The Overwrite-from-JSON dialog is mounted inside DetailsTab (it needs
 * the tab's refetch + screen/field counts), but its trigger lives in the
 * page header so users can open it without scrolling to the bottom of the
 * Details form. Zustand bridges the two without prop-drilling through
 * Tabs.
 */
interface TemplateEditUiState {
  overwriteDialogOpen: boolean;
  setOverwriteDialogOpen: (open: boolean) => void;
  openOverwriteDialog: () => void;
  closeOverwriteDialog: () => void;
}

export const useTemplateEditUiStore = create<TemplateEditUiState>((set) => ({
  overwriteDialogOpen: false,
  setOverwriteDialogOpen: (open) => set({ overwriteDialogOpen: open }),
  openOverwriteDialog: () => set({ overwriteDialogOpen: true }),
  closeOverwriteDialog: () => set({ overwriteDialogOpen: false }),
}));
